<template>
  <div id="listadousuariosregistrados">
    <div v-if="!items.length">
      <div class="ui icon warning message">
        <i class="user icon"></i>
        <div class="content">
          <div class="header">
            {{ $t("components.registeredUsers.No_hay_usuarios") }}
          </div>
          <p>{{ $t("components.registeredUsers.Aniade_con_boton_registrar") }}</p>
        </div>
      </div>
      <router-link class="item" to="/newControlAccessCard">
        <div class="ui left floated small olive labeled icon button">
          <i class="plus icon"></i> {{$t("components.registeredUsers.Registrar_nuevo")}}
        </div>
      </router-link>
    </div>

    <table v-if="items.length" class="ui compact celled definition table selectable sortable">
      <thead class="full-width">
        <tr>
          <th class="ten wide">{{ $t("components.registeredUsers.Nombre") }}</th>
          <th class="center aligned two wide">{{ $t("components.registeredUsers.UUID_mifare") }}</th>
          <th class="center aligned three wide">{{ $t("components.registeredUsers.Estado") }}</th>
          <th class="one wide no-sort"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in items" v-bind:key="u._id">
          <td :class="{negative : !getEstadoUsuario(u)}">
            <div class="ui accordion">
              <div class="title" style="font-size: 16px;">
                 {{ (u.usuarioSistema != null) ? (u.usuarioSistema.name + ' (' + u.usuarioSistema.login + ')') : u.description }}
              </div>
              <div class="content ">
                <p class="transition visible" style="display: block !important; margin-top:10px;">
                  <strong>{{ $t("components.registeredUsers.Accesos_a_salas") }}</strong>: <span style="font-weight: normal" v-if="u.controllers.length === 0">{{ $t("components.registeredUsers.Ninguna") }}</span>
                  <ul style="font-weight: normal !important; margin-top:5px;" v-if="u.controllers.length > 0">
                    <li v-for="c in u.controllers" v-bind:key="c._id">
                      {{ c.description }}
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </td>
          <td class="center aligned" :class="{ negative : !getEstadoUsuario(u) }">{{ u.userid }}</td>
          <td class="center aligned" :class="{ negative : !getEstadoUsuario(u) }">
            <div class="ui accordion">
              <div class="title ">
                <i class="icon" :class="{ checkmark : getEstadoUsuario(u), close: !getEstadoUsuario(u) }"></i>
              </div>
              <div class="left aligned content">
                <p class="transition visible" style="display: block !important;">
                  <ul style="font-weight: normal !important;">
                    <li><strong>{{ u.enabled ? $t("components.registeredUsers.Habilitado") : $t("components.registeredUsers.Deshabilitado") }}</strong></li>
                    <li><strong>{{ getTextoInfoCaducidad(u) }}</strong></li>
                  </ul>
                </p>
              </div>
            </div>
          </td>
          <td class="right aligned collapsing">
            <div class="ui icon buttons mini">
              <router-link class="item" :to="'/controlAccessCard/' + u._id">
                <button class="ui button">
                  <i class="pencil alternate icon"></i>
                </button>
              </router-link>
              <button class="ui red button" @click="unsubscribe(u._id)">
                <i class="times icon"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="4">
            <router-link class="item" to="/newControlAccessCard">
              <div class="ui right floated small olive labeled icon button">
                <i class="plus icon"></i> {{$t("components.registeredUsers.Registrar_nuevo")}}
              </div>
            </router-link>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';

export default {
  name: 'RegisteredControlAccessCards',
  data: function () {
    return {
      items: [],
      moment: Vue.moment,
      table: null,
    };
  },
  methods: {
    refresh: function () {
      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/controlAccessCards').then(response => {
        if (response) {
          if (this.table != null) {
            this.table.destroy();
          }

          this.items = response.data.users;

          setTimeout(() => {
           this.table = $('table').DataTable({
              destroy: true,
              language: this.$i18n.t('components.datatable_language')
            })
            .on('draw', () => {
              $('table .accordion').accordion({
                selector: {
                  trigger: '.title'
                }
              });
            });

            $('#listadousuariosregistrados .accordion').accordion({
              selector: {
                trigger: '.title'
              }
            });
          }, 500);
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.common.Error'),
          text: e
        });
      });
    },
    getEstadoUsuario: function (user) {
      if (user == null) return false;
      if (!user.enabled) return false;
      if ((user.caducidad != null) && this.moment(user.caducidad) <= this.moment()) return false;
      return true;
    },
    getTextoInfoCaducidad: function (user) {
      if (user.caducidad != null) {
        if (this.moment(user.caducidad) <= this.moment()) {
          return this.$i18n.t('components.registeredUsers.Caducado_desde') + this.moment(user.caducidad).locale(this.$i18n.locale).format('LL');
        } else {
          return this.$i18n.t('components.registeredUsers.Caduca_el') + this.moment(user.caducidad).locale(this.$i18n.locale).format('LL');
        }
      } else {
        return this.$i18n.t('components.registeredUsers.Caduca_nunca');
      }
    },
    unsubscribe: function (idUSer) {
      this.$swal.fire({
        title: this.$i18n.t('components.registeredUsers.Esta_seguro'),
        text: this.$i18n.t('components.registeredUsers.Se_marca_como_borrado'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$i18n.t('components.common.Si'),
        cancelButtonText: this.$i18n.t('components.common.No')
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.delete('/controlAccessCard/' + idUSer).then(response => {
            this.$swal.fire(
              this.$i18n.t('components.registeredUsers.Borrado'),
              this.$i18n.t('components.registeredUsers.Se_ha_borrado'),
              'success'
            );
            setTimeout(() => {
              this.refresh();
            }, 500);
          }).catch(e => {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.registeredUsers.Hay_un_error'),
              text: e
            });
          });
        }
      });
    }
  },
  mounted: function () {
    this.refresh();
  }
};
</script>
